"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Modal = require("./Modal.styles");

var Title = function Title(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return (0, _jsxRuntime.jsx)("h2", {
    css: [_elements.heading.styles.h2, _Modal.styles.color, process.env.NODE_ENV === "production" ? "" : ";label:Title;"],
    className: className,
    children: children
  });
};

Title.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string
};
Title.defaultProps = {
  children: undefined,
  className: undefined
};
var _default = Title;
exports["default"] = _default;
//# sourceMappingURL=Title.js.map